import { getBookingServicesLabel } from "../services/dashboard";

export type UpcomingBookingView = {
  id: string | number;
  customer: string;
  date: string;
  time: string;
  amount: number;
  services_count: number;
  services_label: string;
  staff: string;
  status?: string;
};

export function formatUpcomingBookingRow(
  booking: Record<string, unknown>
): UpcomingBookingView {
  const user = booking.user as { name?: string } | undefined;
  const items = booking.items as Array<{
    employee?: { name?: string };
    business_service?: { name?: string };
    product?: { name?: string };
    sunbed?: { name?: string };
  }> | undefined;
  const users = booking.users as Array<{ name?: string }> | undefined;

  const dateTime = String(booking.date_time ?? "");
  const staffFromItem = items?.find((item) => item.employee?.name)?.employee?.name;
  const staffFromUsers = users?.[0]?.name;

  return {
    id: booking.id as string | number,
    customer: user?.name ?? "Unknown",
    date: dateTime.split("T")[0] ?? "",
    time: dateTime
      ? new Date(dateTime).toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      : "",
    amount: Number(booking.amount_to_pay ?? 0),
    services_count: items?.length ?? 0,
    services_label: getBookingServicesLabel(items),
    staff: staffFromItem ?? staffFromUsers ?? "Unassigned",
    status: String(booking.status ?? ""),
  };
}

export function formatNextAppointmentLabel(
  next: {
    customer?: string | null;
    time?: string | null;
    services_label?: string | null;
  } | null | undefined
): string {
  if (!next?.time) return "None today";
  const name = next.customer ?? "Client";
  const service = next.services_label && next.services_label !== "—" ? ` · ${next.services_label}` : "";
  return `${next.time} — ${name}${service}`;
}

export function toDateInputValue(date: Date): string {
  return date.toISOString().split("T")[0];
}

export function getTodayRange(): { startDate: string; endDate: string } {
  const today = toDateInputValue(new Date());
  return { startDate: today, endDate: today };
}
